
import { css } from "@emotion/react"
import { FONT_COLOR } from "../../resources/color"

export const Empty: React.FC = () => {
    return (
      <div css={containerStyle}>
        投稿がまだありません。
      </div>
    )
}

const containerStyle = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100vw',
  height: '100vh',
  color: FONT_COLOR.SECONDARY,
  fontSize: 20,
  fontWeight: 'bold'
})